import createAxios from './api'

const PATH = 'userVerification'

export default {

  async processRegula(req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/process/regula`, req)

    return resp.data
  },

  async resetVerification() {
    const axios = await createAxios()
    await axios.post(`${PATH}/reset`)
  },

  async getUserVerificationStatus() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}`)

    return resp.data
  }

}
